import { Alert, AlertTitle, Box } from '@mui/material';
import { FixedCenterCircularProgress } from 'src/components/progress/fixed-center-circular-progress';
import { useCheckFeatureFlag } from 'src/lib/hooks/useCheckFeatureFlag';
import { useTranslate } from 'src/locales';

type Props = {
  flagName: string;
  children: React.ReactNode;
};

export function FeatureFlagGuard({ flagName, children }: Props) {
  const checkFeatureFlag = useCheckFeatureFlag(flagName);
  const { t } = useTranslate();

  if (checkFeatureFlag) {
    return children;
  } else {
    if (checkFeatureFlag === null) {
      return <FixedCenterCircularProgress />;
    }

    return (
      <Box sx={{ m: 2 }}>
        <Alert severity="error">
          <AlertTitle sx={{ textTransform: 'capitalize' }}>{t('errors.error')}</AlertTitle>
          This feature is not available now!
        </Alert>
      </Box>
    );
  }
}
